import { Currency } from '@/constants/currency'
import { api } from '@/lib/api'

export function getTransactionCurrencies() {
  return api.get<Currency[]>(`/v1/me/transaction-currencies`)
}
